
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-46bfa9ff&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CategoryModal.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CategoryModal.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-46bfa9ff!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CategoryModal.vue"),
  /* scopeId */
  "data-v-46bfa9ff",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/components/CategoryModal.vue
// module id = ./dev/src/components/CategoryModal.vue
// module chunks = 0